import { useCountDown } from "ahooks"

export const CountdownNumber = ({ to }: { to: number }) => {
  const [, formattedRes] = useCountDown({
    targetDate: to,
  })
  const { seconds } = formattedRes
  return <span>{seconds}s</span>
}
